import React from "react";
import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";

const GestionServiciosContratados = () => {
  const bucketUrl = process.env.REACT_APP_BUCKET;

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="container text-center">
          <div className="row">
            <div className="col">
              <div className="TituloPrincipal text-center">
                <br /> <h1>Gestión de Servicios Contratados</h1>
              </div>
              <center>
                <hr className="linea-horizontal"></hr>
              </center>
            </div>
            <div className="col">
              <div className="Text_Buttons_Radio_buttons">
              </div>
            </div>
          </div>
        </div>

        <div className="table-container text-center">
          <table className="styled-table text-center">
            <thead>
              <tr>
                <th>#</th>
                <th>Cliente</th>
                <th>Año</th>
                <th>Póliza</th>
                <th>Inventario</th>
              </tr>
            </thead>

            <tbody>
              
              {/* CVeerkamp */}
              <tr>
                <td rowSpan="2">1</td>

                <td rowSpan="2">
                  <b>CVeerkamp</b>
                </td>

                <td>2025</td>
                <td></td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/xlsx/gestion-servicios-inventarios/Inventario-de-Bienes-Veerkamp.xlsx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Inventario
                  </a>
                </td>
              </tr>

              <tr>
                <td>2026</td>

                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/gestion-servicios-contratados/cveerkamp-2026"
                  >
                    Ver Póliza
                  </Button>
                </td>
              </tr>

              {/* Eficasia */}
              <tr>
                <td rowSpan="2">2</td>

                <td rowSpan="2">
                  <b>Eficasia</b>
                </td>

                <td>2025</td>

                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/gestion-servicios-contratados/eficasia-2025"
                  >
                    Ver Póliza
                  </Button>
                </td>

                <td rowSpan="2">
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/xlsx/gestion-servicios-inventarios/251211-Inventario-Eficasia.xlsx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Inventario
                  </a>
                </td>
              </tr>

              <tr>
                <td>2026</td>

                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/gestion-servicios-contratados/eficasia-2026"
                  >
                    Ver Póliza
                  </Button>
                </td>
              </tr>

              {/* Enestas */}
              <tr>
                <td>3</td>
                <td><b>Enestas</b></td>
                <td>2025</td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/gestion-servicios-contratados/enestas-2025"
                  >
                    Ver Póliza
                  </Button>
                </td>
                <td></td>
              </tr>

              {/* La Comer */}
              <tr>
                <td>4</td>
                <td><b>La Comer</b></td>
                <td>2025</td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/gestion-servicios-contratados/la-comer-2025"
                  >
                    Ver Póliza
                  </Button>
                </td>
                <td></td>
              </tr>

              {/* Havas */}
              <tr>
                <td>5</td>
                <td><b>Havas</b></td>
                <td>2026</td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/gestion-servicios-contratados/havas-2026"
                  >
                    Ver Póliza
                  </Button>
                </td>
                <td></td>
              </tr>

              {/* ICMyL */}
              <tr>
                <td>6</td>
                <td><b>ICMyL</b></td>
                <td>2025</td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/gestion-servicios-contratados/icmyl-2025"
                  >
                    Ver Póliza
                  </Button>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/xlsx/gestion-servicios-inventarios/260330-Invenatrio-Bienes.xlsx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Inventario
                  </a>
                </td>
              </tr>

              {/* ICACC */}
              <tr>
                <td>7</td>
                <td><b>ICACC</b></td>
                <td>2025</td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/gestion-servicios-contratados/icacc-2025"
                  >
                    Ver Póliza
                  </Button>
                </td>
                <td></td>
              </tr>

              {/* Mgavilan */}
              <tr>
                <td>8</td>
                <td><b>Mgavilan</b></td>
                <td>2025</td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/gestion-servicios-contratados/mgavilan-2025-sw"
                  >
                    Ver Póliza de Switches
                  </Button>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/gestion-servicios-contratados/mgavilan-2025-fw"
                  >
                    Ver Póliza de Firewall
                  </Button>
                </td>
                <td></td>
              </tr>

              {/* Herdez */}
              <tr>
                <td>9</td>
                <td><b>Herdez</b></td>
                <td>2024</td>
                <td></td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/xlsx/gestion-servicios-inventarios/240216-Listado-de-activos-Herdez.xlsx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Listado de Activos
                  </a>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/xlsx/gestion-servicios-inventarios/240731-Relacion-APs-Herdez.xlsx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Relación Apps
                  </a>
                </td>
              </tr>   

              {/* MCM Waas */}
              <tr>
                <td>10</td>
                <td><b>MCM Waas</b></td>
                <td>2025</td>
                <td></td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/xlsx/gestion-servicios-inventarios/251217-Inventario-Netjer-MCM.xlsx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Inventario
                  </a>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/xlsx/gestion-servicios-inventarios/251217-MCM-Clientes-Vigentes.xlsx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Clientes Vigentes
                  </a>
                </td>
              </tr>            

              {/* IKE */}
              <tr>
                <td>11</td>
                <td><b>IKE</b></td>
                <td>2026</td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/gestion-servicios-contratados/ike-2026"
                  >
                    Ver Póliza
                  </Button>
                </td>
                <td></td>
              </tr>  

              {/* UCI */}
              <tr>
                <td>12</td>
                <td><b>UCI</b></td>
                <td>2025</td>
                <td></td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/xlsx/gestion-servicios-inventarios/260330-Inventario-de-Equipos-UCI.xlsx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Inventario
                  </a>
                </td>
              </tr>

              {/* K-NETWORKING */}
              <tr>
                <td>13</td>
                <td><b>K-Networking</b></td>
                <td>2026</td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/gestion-servicios-contratados/k-Networking-2026"
                  >
                    Ver Póliza
                  </Button>
                </td>
                <td></td>
              </tr>

              {/* UAM XOCHIMILCO */}
              <tr>
                <td>14</td>
                <td><b>UAM Xochimilco</b></td>
                <td>2026</td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/gestion-servicios-contratados/uam-xochimilco-2026"
                  >
                    Ver Póliza
                  </Button>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/xlsx/gestion-servicios-inventarios/Seriales-X5320-Xochimilco.xlsx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Inventario
                  </a>
                </td>
              </tr>

              {/* INNES AIRES */}
              <tr>
                <td>15</td>
                <td><b>INNES AIRES</b></td>
                <td>2026</td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/gestion-servicios-contratados/innes-aires-2026"
                  >
                    Ver Póliza
                  </Button>
                </td>
                <td></td>
              </tr>

            </tbody>
          </table>
        </div>
      </Container>
    </>
  );
};

export default GestionServiciosContratados;